import { Center } from '@chakra-ui/react';
import { ReleaseVersionReorderBody } from 'types/releases';

export const adjustToIndexForSwappingNeighborsAndDownDragging = (
  fromIndex: number,
  toIndex: number
) => (toIndex - 1 >= fromIndex ? toIndex - 1 : toIndex);

export const calculateIndex = (
  fromIndex: number,
  toIndex: number,
  length: number,
  isTop: boolean
) => {
  if (toIndex === fromIndex) {
    return toIndex;
  }

  const recalculatedIndex = adjustToIndexForSwappingNeighborsAndDownDragging(
    fromIndex,
    toIndex
  );

  return isTop
    ? recalculatedIndex
    : Math.min(length - 1, recalculatedIndex + 1);
};

export const getVersionReorderBody = (
  movingGuid: string,
  afterGuid: string,
  notToTop = false
): ReleaseVersionReorderBody => {
  const requestBody: ReleaseVersionReorderBody = {
    versionGuid: movingGuid,
  };

  if (notToTop) {
    requestBody.afterVersionGuid = afterGuid;
  }

  return requestBody;
};

export const CONTROLS_SIZE = 32;
export const OPTIONS_SIZE = 60;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - CONTROLS_SIZE - OPTIONS_SIZE) * percent;
};

export const getColumns = (totalWidth?: number) => [
  {
    accessorKey: 'controls',
    header: <Center w={5}>#</Center>,
    accessory: true,
    size: CONTROLS_SIZE,
    sx: { pl: 1 },
  },
  {
    accessorKey: 'title',
    header: 'Title',
    sx: { pl: 0 },
    enableResizing: true,
    size: getColumnSize(0.25, totalWidth),
  },
  {
    accessorKey: 'song',
    header: 'Song',
    enableResizing: true,
    size: getColumnSize(0.25, totalWidth),
  },
  {
    accessorKey: 'date',
    header: 'Date',
    minSize: 88,
    size: getColumnSize(0.25, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: OPTIONS_SIZE,
    header: '',
    contextMenu: true,
  },
];
